import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteExternalDegrees = () => {
    const [externalDegrees, setExternalDegrees] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchExternalDegrees();
    }, []);


    const fetchExternalDegrees = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/externalDegree/deleted');
            const data = await response.json();
            setExternalDegrees(data);
        } catch (error) {
            console.error('Error fetching deleted external degrees:', error);
        }
    };

    const handleRestore = async (externalDegreeId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this external degree?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/externalDegree/restore/${externalDegreeId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful restoration
                        const updatedExternalDegrees = externalDegrees.filter(externalDegree => externalDegree.id !== externalDegreeId);
                        setExternalDegrees(updatedExternalDegrees);
                        
                        // Show success message
                        Swal.fire({
                            title: "Restored!",
                            text: "The external degree has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore external degree');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the external degree.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring external degree:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the external degree.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (externalDegreeId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to permanently delete this external degree? This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/externalDegree/delete/permanent/${externalDegreeId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedExternalDegrees = externalDegrees.filter(externalDegree => externalDegree.id !== externalDegreeId);
                        setExternalDegrees(updatedExternalDegrees);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The external degree has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete external degree permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the external degree permanently.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting external degree permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the external degree permanently.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter external degrees based on search term
    const filteredExternalDegrees = externalDegrees.filter(externalDegree => 
        (externalDegree.courseName && externalDegree.courseName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (externalDegree.university && externalDegree.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (externalDegree.duration && externalDegree.duration.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (

        <div>

            <AdminDashboard />

            <div className='AllViews-admin-course'>

                <div className="search-icon-admin admin-course-search">

                    <h1>DELETE EXTERNAL DEGREES</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                   
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                            <tr>
                                    <th>External Degree Name</th>
                                    <th>Institute Name</th>
                                    <th>Start Date</th>
                                    <th>Duration</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredExternalDegrees.map((externalDegree) => (
                                    <tr key={externalDegree.id}>
                                        <td>{externalDegree.courseName}</td>
                                        <td>{externalDegree.university}</td>
                                        <td>{new Date(externalDegree.startDate).toLocaleDateString('en-CA')}</td>
                                        <td>{externalDegree.duration}</td>
                                        <td>
                                            {externalDegree.website ? (
                                                <a href={externalDegree.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                            ) : (
                                                <span style={{ color: '#999' }}>No Website</span>
                                            )}
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(externalDegree.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(externalDegree.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )

}

export default DeleteExternalDegrees